import { useQuery, useInfiniteQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import queryKey from "../../../enumerations/queryKey";
import {
  apiGetInboxCounter,
  apiGetMessageList,
  apiUpdateMessageReadStatus,
  apiReadAllMessage,
  apiGetAnnouncementList
} from "../service";

export const useGetUnreadCount = (options) => {
  return useQuery(
    [queryKey.UNREAD_COUNT],
    () => apiGetInboxCounter().then((res) => res.data.data),
    {
      ...options,
    }
  );
};

export const useGetMessageList = (options, params) => {
  return useInfiniteQuery(
    [queryKey.MESSAGE_LIST],
    ({ pageParam = 1 }) =>
      apiGetMessageList({ ...params, pageSize: 10, page: pageParam }).then((res) => {
        return res.data?.data;
      }),
    {
      ...options,
      cacheTime: 0,
    }
  );
};

export const useUpdateMessageStatus = () => {
  const cache = useQueryClient();
  return useMutation(
    (id, params) =>
      apiUpdateMessageReadStatus(id, params).then((res) => res.data.data),
    {
      onSuccess: () => {
        cache.invalidateQueries(queryKey.MESSAGE_LIST);
      },
    }
  );
};

export const useReadAllMessage = () => {
  const cache = useQueryClient();
  return useMutation(
    (params) =>
      apiReadAllMessage(params).then((res) => res.data.data),
    {
      onSuccess: () => {
        cache.invalidateQueries(queryKey.MESSAGE_LIST);
      },
    }
  );
};

export const useGetAnnouncementList = (options, params) => {
  return useInfiniteQuery(
    [queryKey.ANNOUNCE_LIST],
    ({ pageParam = 1 }) =>
      apiGetAnnouncementList({ ...params, pageSize: 10, page: pageParam }).then((res) => {
        return res.data?.data;
      }),
    {
      ...options,
      cacheTime: 0,
    }
  );
};

